module.exports = __webpack_public_path__ + "static/media/shuffle-white-icon.249f1948.svg";